import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { fetchUserRoleCode } from "./utils/authService";

export default function withAuth(ComponentToProtect) {

  return class extends Component {
    constructor() {
      super();
      this.state = {
        isAuthenticated: false,
        loading: true,
        redirect: false,
      };
    }

    componentDidMount() {
      axios.defaults.baseURL = process.env.REACT_APP_API_URL;
      axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
      let token = localStorage.getItem('token');
      axios({
        method: "get",
        url: "/checkToken",
        headers: { "Authorization": `Bearer ${token}` }
      })
        .then((res) => {
          this.setState({ isAuthenticated: true });
          fetchUserRoleCode(res?.data.authData.user?.roleId);
          localStorage.setItem('user', JSON.stringify(res.data.authData.user))
          this.setState({ loading: false });
        })
        .catch((err) => {
          console.log(err)
          console.log(`Access: ${this.state.isAuthenticated}`);
          this.props.history.push('/login')
          this.setState({ loading: false, redirect: true });
        });
    }
    render() {
      const { loading, redirect } = this.state;
      if (loading) {
        return null;
      }
      if (redirect) {
        return <Redirect to="/login" />;
      }
      return <ComponentToProtect {...this.props} />;
    }
  };
}
